import { useState, useEffect } from 'react';
/* eslint-disable */
import { Box, Grid } from '@mui/material';
import TransactionTabs from './AepsTabs';
import TransactionDetails from './AepsForm';
import AuthenticationBox from './AepsAuth';
import BreadcrumbComponent from 'views/Components/BreadCrumb';
import { handleCatchError } from 'utils/CatchHandler';
import { checkMerchantOrBCAPI, checkPermissionGet } from 'utils/API/Merchant APIs/MerchantApiCalls';
import Spinner from 'views/Components/LoadingSinner';
import ReKYCDialog from 'views/Components/Dialogs/ReKycDialog';
import BcConvertModal from 'views/Components/BcConvertModal';
import { useNavigate } from 'react-router';
const tabLabels = [
    'Cash Withdrawal',
    'Balance Enquiry',
    'Mini Statement'
    // , 'Aadhaar Deposit'
];
import {
    aadharExistApi,
    balanceEnquiryApi,
    cashWithdrawalApi,
    miniStatementApi,
    checkPermissionApi
} from 'utils/API/Merchant APIs/UpdatedAPIs/AEPSUpdatedApiCall'; // Add all required APIs here
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TransactionSuccessCard from './AepsSuccess';
import AadharMobileDialog from './AepsDailyAuth';
import withAccessControlResetPassword from 'utils/HOC/resetPasswordHOC';
import WithAuthAadhar from 'routes/iciciauthentication/aadharAuth';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setResetFalse } from '../../../../redux/ResetSlice';
import { fetchWalletBalanceAsync } from 'redux/WalletSlice';
import AepsFinoAuth from 'routes/iciciauthentication/AepsFinoAuth';

const commonStyles = {
    m: 0
};

const loadingTexts = [
    'Fetching Aadhaar details...',
    'Verifying identity...',
    'Validating document information...',
    'Connecting to UIDAI servers...',
    'Securing your data...',
    'Decrypting Aadhaar response...',
    'Finalizing authentication...'
];
function AepsTransaction2() {
    const dispatch = useDispatch();
    const [tabIndex, setTabIndex] = useState(0);
    const [aadhaarNumber, setAadhaarNumber] = useState('');
    // const [bankList, setBankList] = useState([]);
    const [bank, setBank] = useState(null);
    const [amount, setAmount] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [showAmount, setShowAmount] = useState(true);
    const [responseData, setResponseData] = useState('');
    const [responseStatus, setResponseStatus] = useState('');
    const [isCheckLoading, setIsCheckLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [merchantModalOpen, setMerchantModalOpen] = useState(false);
    const [isBcConvertPending, setIsBcConvertPending] = useState(false);
    const [reKycDetails, setReKycDetails] = useState({ shouldOpen: false });
    const [open, setOpen] = useState(false);
    const [aadhaarError, setAadhaarError] = useState('');
    const [mobileError, setMobileError] = useState('');
    const [amountError, setAmountError] = useState('');

    const isReset = useSelector((state) => state.reset.isReset);
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');
    const breadcrumbRoutes = [{ label: 'AEPS', path: '' }];
    const navigate = useNavigate();
    const disableScanButton = !aadhaarNumber || !bank || !mobileNumber || ((tabIndex === 0 || tabIndex === 3) && !amount);

    const handleFingerprintCapture = (data) => {
        if (data) {
            handleTransactionSubmit({ location, data });
        }
    };

    useEffect(() => {
        if (isReset) {
            if (responseStatus || responseData) {
                // reset only if not already empty
                setResponseStatus('');
                setResponseData('');
            }
            dispatch(setResetFalse());
        }
    }, [isReset]);

    const handleCheckPermission = async () => {
        try {
            setIsCheckLoading(true);
            const agentid = localStorage.getItem('id');
            const payload = { agentid };
            const merchantBcCheckResponse = await checkMerchantOrBCAPI(payload);

            const agentType = merchantBcCheckResponse?.data?.agentType;
            const pendingStatus = merchantBcCheckResponse?.data?.isPending;
            setIsBcConvertPending(pendingStatus);

            if (
                agentType === 'Merchant' ||
                pendingStatus ||
                shouldshowEsign === 'true' ||
                localStorage.getItem('merchantToBcStatus') === 'rejected'
            ) {
                setMerchantModalOpen(true);
                return;
            }

            const response = await checkPermissionApi();
            const Data = response?.data?.data;

            const aeps_2FA_data = Data?.finoAeps2FA;
            const aepsType = Data?.aepsType;
            const statusMessage = Data?.apiStatus;
            const isWhitelabel = Data?.whitelabel;
            const aepsStatus = Data?.aepsStatus;
            const isTwoFactorEnabled = Number(Data?.finoAeps2FA) === 1;

            console.log('Data', Data);

            if (aepsStatus !== 'enabled') {
                globalNotifyError(statusMessage || 'AEPS services have been disabled for your account.');
                navigate('/merchant-home');
                return;
            }

            if (!isWhitelabel) {
                setReKycDetails({ shouldOpen: true });
            } else {
                setReKycDetails({ shouldOpen: false });
            }

            // if (aepsType === 'Fingpay') {
            if (Data?.finoAeps2FA !== undefined) {
                if (!isTwoFactorEnabled) {
                    setOpen(true);
                }
            }
            // }
            setIsCheckLoading(false);
        } catch (error) {
            setIsCheckLoading(false);
            console.log(error.message);
            handleCatchError(error);
        } finally {
            setIsCheckLoading(false);
        }
    };

    useEffect(() => {
        handleCheckPermission();
    }, []);

    const handleTransactionSubmit = async ({ location, data }) => {
        const nationalBankIdentification = bank?.iinno;
        const bankName = bank?.bankName.replace(/^⭐\s*/, '');
        const aadhaarNo = aadhaarNumber;
        const mobilenumber = mobileNumber;
        try {
            setIsLoading(true);

            const basePayload = {
                // agentid,
                bankName,
                bank: bankName,
                nationalBankIdentification,
                aadhaarNo,
                mobileNumber,
                data,
                aepsType: '2'
            };

            let apiFunc = null;
            let payload = { ...basePayload };

            switch (tabIndex) {
                case 0: // Cash Withdrawal
                    apiFunc = cashWithdrawalApi;
                    payload.transactionAmount = amount;
                    break;

                case 1: // Balance Enquiry
                    apiFunc = balanceEnquiryApi;
                    break;

                case 2: // Mini Statement
                    apiFunc = miniStatementApi;
                    break;

                // case 3: // Aadhaar Deposit
                //     apiFunc = finoCashDepositApi;
                //     payload.amount = amount;
                //     payload.wallet = 1;
                //     break;

                default:
                    globalNotifyError('Invalid transaction type');
                    return;
            }

            const response = await apiFunc(payload);
            const Data = response?.data;
            const responseData = response?.response || {};

            setIsLoading(false);

            const finalData = Data || responseData?.data;

            const isSuccess = finalData?.success === true || finalData?.status === true || finalData?.status === 'SUCCESS';

            if (isSuccess) {
                dispatch(fetchWalletBalanceAsync());
                globalNotifySuccess(finalData?.message || 'Transaction Successful');
                const object = finalData?.data;
                setResponseData(object);
                setResponseStatus(true);
            } else {
                const errorMsg = finalData?.message || finalData?.data?.message || response?.message || 'Transaction Failed';
                globalNotifyError(errorMsg);
                setResponseStatus(false);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error.message);
            handleCatchError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleBcModalClose = () => {
        setMerchantModalOpen(false);
    };

    useEffect(() => {
        setResponseStatus('');
        setResponseData('');

        if (tabIndex === 0 || tabIndex === 3) {
            setShowAmount(true);
        } else {
            setShowAmount(false);
        }
    }, [tabIndex]);

    const handleCheckAadhaarExist = async () => {
        if (tabIndex !== 0) return;
        try {
            setIsLoading(true);
            const payload = {
                aadharNo: aadhaarNumber,
                // agentid: localStorage.getItem('user_id'),
                type: 'AP'
            };
            const response = await aadharExistApi(payload);

            if (response?.data?.status) {
                const errorMsg = response?.data?.message || 'Invalid Aadhaar number';
                setAadhaarError(errorMsg);
            } else {
                setAadhaarError('');
            }

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.log(error.message);
            handleCatchError(error);
            setAadhaarError('Failed to verify Aadhaar'); // Fallback error
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (tabIndex === 0 && aadhaarNumber.length === 12) {
            handleCheckAadhaarExist();
        }
    }, [tabIndex, aadhaarNumber]);

    return (
        <>
            <BreadcrumbComponent routes={breadcrumbRoutes} />
            <Box
                sx={{
                    width: '100%',
                    height: 'auto',
                    backgroundColor: '#fff',
                    ...commonStyles,
                    borderRadius: 2,
                    padding: '20px 10px',
                    '@media screen and (min-width: 600px)': {
                        padding: 2
                    }
                }}
            >
                <Box sx={{ p: 4 }}>
                    <TransactionTabs tabIndex={tabIndex} setTabIndex={setTabIndex} tabLabels={tabLabels} />

                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6}>
                            <TransactionDetails
                                aadhaarNumber={aadhaarNumber}
                                setAadhaarNumber={setAadhaarNumber}
                                bank={bank}
                                setBank={setBank}
                                amount={amount}
                                setAmount={setAmount}
                                mobileNumber={mobileNumber}
                                setMobileNumber={setMobileNumber}
                                tabIndex={tabIndex}
                                showAmount={showAmount}
                                aadhaarError={aadhaarError}
                                setAadhaarError={setAadhaarError}
                                mobileError={mobileError}
                                setMobileError={setMobileError}
                                amountError={amountError}
                                setAmountError={setAmountError}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            {responseStatus ? (
                                <TransactionSuccessCard responseData={responseData} tabIndex={tabIndex} ServiceType={'fino'} />
                            ) : (
                                <AuthenticationBox
                                    onCapture={handleFingerprintCapture}
                                    onStatusChange={(status) => {
                                        console.log('Status:', status);
                                    }}
                                    disableScanButton={disableScanButton || !!aadhaarError || !!mobileError || !!amountError}
                                    responseStatus={responseStatus}
                                    tabIndex={tabIndex}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <AadharMobileDialog open={open} handleClose={() => setOpen(false)} aepsType={2} />
            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    serviceName={'aeps'}
                    shouldshowEsign={shouldshowEsign}
                />
            )}

            <Spinner loading={isLoading} texts={loadingTexts} />
            <Spinner loading={isCheckLoading} />
            <ToastContainer />
            {reKycDetails.shouldOpen && <ReKYCDialog />}
        </>
    );
}

export default withAccessControlResetPassword(AepsFinoAuth(AepsTransaction2));
